import { render } from "./ButtonOutlined.vue?vue&type=template&id=3c3828ba&ts=true"
import script from "./ButtonOutlined.vue?vue&type=script&lang=ts"
export * from "./ButtonOutlined.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__